export type IrrDetailsCalcParams = {
    pivotSpeedPercent: string | number;
    irrigationDepth: string | number | undefined;
    pivotMinDepth: number;
    precision?: number;
};

export const calculateIrrigationDetails = (
    params: IrrDetailsCalcParams,
): IrrDetailsCalcParams => {
    const { pivotSpeedPercent, pivotMinDepth, irrigationDepth, precision } =
        params;

    const speed: number = +pivotSpeedPercent;
    const irrDepth: number = +(irrigationDepth ?? 0);
    const minDepth: number = pivotMinDepth;
    const numsAfterDecimal: number =
        precision && precision >= 0 ? precision : 2;

    if (irrDepth > 0) {
        params.pivotSpeedPercent = ((minDepth / irrDepth) * 100).toFixed(
            numsAfterDecimal,
        );
        params.irrigationDepth = irrDepth.toFixed(numsAfterDecimal);
    } else if (speed > 0) {
        params.pivotSpeedPercent = speed.toFixed(numsAfterDecimal);
        params.irrigationDepth = (minDepth / (speed / 100)).toFixed(
            numsAfterDecimal,
        );
    } else {
        const emptyNum = 0;
        params.pivotSpeedPercent = emptyNum.toFixed(numsAfterDecimal);
        params.irrigationDepth = emptyNum.toFixed(numsAfterDecimal);
    }
    return params;
};
